import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAfF2ONlIAfIgPXAYmZgn0PEgv93VtoB40",
  authDomain: "horeca-lead-generation.firebaseapp.com",
  projectId: "horeca-lead-generation",
  storageBucket: "horeca-lead-generation.appspot.com",
  messagingSenderId: "387766896359",
  appId: "1:387766896359:web:2ea79484f2d28a65868442"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
